const Footer = () => {
  return (
    <footer className="mt-auto border-t border-stone-200 bg-white">
      <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-6 text-sm text-stone-500 sm:flex-row sm:px-6 lg:px-8">
        <p className="font-medium text-stone-700">SalamFood</p>
        <p>Fresh meals, delivered with care.</p>
      </div>
    </footer>
  );
};

export default Footer;
